import { cancellationOptions } from "conts/profileConst";
import { useState } from "react";

export const useCancellation = (formData, setFormData) => {
	const [cancellationErrors, setCancellationErrors] = useState({});

	const getAvailableOptions = () => {
		const selectedValues = formData.cancellation_policy.map(
			(policy) => policy.policy,
		);
		return cancellationOptions.filter(
			(option) => !selectedValues.includes(option.value),
		);
	};

	const handleAddCancellationPolicy = () => {
		const defaultPolicy =
			getAvailableOptions()[0].value || cancellationOptions[0].value;
		if (formData.cancellation_policy.length < cancellationOptions.length) {
			setFormData((prevState) => ({
				...prevState,
				cancellation_policy: [
					...prevState.cancellation_policy,
					{ policy: defaultPolicy || "", percentage: "" },
				],
			}));
		}
	};

	const handleRemoveCancellationPolicy = (policy) => {
		setFormData((prevState) => ({
			...prevState,
			cancellation_policy: prevState.cancellation_policy.filter(
				(currentPolicy) => currentPolicy.policy !== policy,
			),
		}));
	};

	const handlePolicyChange = (key, policy, newValue) => {

		const updatedPolicies = formData.cancellation_policy.map((currentPolicy) =>
			currentPolicy.policy === policy
				? { ...currentPolicy, [key]: newValue }
				: currentPolicy,
		);

		setFormData((prevState) => ({
			...prevState,
			cancellation_policy: updatedPolicies,
		}));
		const conflictErrors = checkConflict(
			policy,
            newValue,
			updatedPolicies,
		);

		validatePolicies(updatedPolicies);
		setCancellationErrors((prev) => ({ ...prev, ...conflictErrors }));
	};

	const checkConflict = (currentPolicy, currentPercentage, policies) => {
		const newErrors = {};
		const conflictMessage = "Conflict with other policies";

		const refund24Hours = policies.find(
			(p) => p.policy === "Less than 24 hours",
		)?.percentage;
		const refund48Hours = policies.find(
			(p) => p.policy === "Less than 48 hours",
		)?.percentage;
		const refund7Days = policies.find(
			(p) => p.policy === "Less than 7 days",
		)?.percentage;

		let errorMessage = "";

		const percentageNumber = Number(currentPercentage);

		if (currentPolicy === "Less than 24 hours") {
			if (
				(refund48Hours && percentageNumber > Number(refund48Hours)) ||
				(refund7Days && percentageNumber > Number(refund7Days))
			) {
				errorMessage = conflictMessage;
			}
		}
		if (currentPolicy === "Less than 48 hours") {
			if (
				(refund24Hours && percentageNumber < Number(refund24Hours)) ||
				(refund7Days && percentageNumber > Number(refund7Days))
			) {
				errorMessage = conflictMessage;
			}
		}
		if (currentPolicy === "Less than 7 days") {
			if (
				(refund24Hours && percentageNumber < Number(refund24Hours)) ||
				(refund48Hours && percentageNumber < Number(refund48Hours))
			) {
				errorMessage = conflictMessage;
			}
		}

		newErrors[currentPolicy] = errorMessage;

		return newErrors;
	};

	const validatePolicies = (policies) => {
		const newErrors = {};
		policies?.forEach(({ policy, percentage }) => {
			let errorMessage = "";

			if (percentage === "" || Number(percentage) === 0) {
				errorMessage = "Value must be filled";
			} else if (Number(percentage) < 5) {
				errorMessage = "Minimum is 5%";
			} else if (Number(percentage) > 90) {
				errorMessage = "Must be up to 90%";
			}

			newErrors[policy] = errorMessage;
		});

		setCancellationErrors(newErrors);
		return newErrors;
	};

	return {
		getAvailableOptions,
		handleAddCancellationPolicy,
		handleRemoveCancellationPolicy,
		handlePolicyChange,
		cancellationErrors,
		validateCancellationPolicy: validatePolicies,
	};
};
